import React from 'react';
import { useIntl } from 'react-intl';
import {
  Col, Container, Icons, Row,
} from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { Dialog, DialogContent, DialogTitle } from '../../../components/base/Dialog/Dialog';
import { dateFormatter } from '../../../utils/formatters';

export default function CheckTypesView({ close = () => {}, current = {} }) {
  const { formatMessage } = useIntl();
  const {
    apply_to_procedures = [],
    apply_to_legal_entity_types = [],
    apply_to_citizenship = [],
    apply_to_registries = [],
  } = current;
  return (
    <Dialog
      className="check-types-view-dialog"
      onClose={close}
      open
    >
      <DialogTitle header="Просмотр шаблона запроса" title={<Icons onClick={close} customIcon icon="close" className="close" />} />
      <DialogContent className="check-types-view-content">
        <div className="check-types-view-table">
          <Row className="row-cols-2">
            <Col className="check-types-view-label" columns={4}>Запрашиваемая информация</Col>
            <Col className="check-types-view-value" columns={8}>{current.name || ''}</Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="check-types-view-label" columns={4}>Источник</Col>
            <Col className="check-types-view-value" columns={8}>{current.source || ''}</Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="check-types-view-label" columns={4}>Наименование сервиса</Col>
            <Col className="check-types-view-value" columns={8}>{current.service_name || ''}</Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="check-types-view-label" columns={4}>Реестр</Col>
            <Col className="check-types-view-value" columns={8}>
              <ul>
                {(apply_to_registries || []).map((i, key) => (<li key={key}>{formatMessage({ id: `check.types.apply_to_registries.${i}` })}</li>))}
              </ul>
            </Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="check-types-view-label" columns={4}>Тип</Col>
            <Col className="check-types-view-value" columns={8}>
              {formatMessage({ id: `check.types.${current.type}` })}
            </Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="check-types-view-label" columns={4}>Услуги</Col>
            <Col className="check-types-view-value" columns={8}>
              <ul>
                {(apply_to_procedures || []).map((i, key) => (<li key={key}>{formatMessage({ id: `procedure.type.${i}` })}</li>))}
              </ul>
            </Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="check-types-view-label" columns={4}>Заявители</Col>
            <Col className="check-types-view-value" columns={8}>
              <ul>
                {(apply_to_legal_entity_types || []).map((i, key) => (<li key={key}>{formatMessage({ id: `user.type.${i}` })}</li>))}
              </ul>
            </Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="check-types-view-label" columns={4}>Гражданство</Col>
            <Col className="check-types-view-value" columns={8}>
              <ul>
                {(apply_to_citizenship || []).map((i, key) => (<li key={key}>{formatMessage({ id: `citizenship.type.${i}` })}</li>))}
              </ul>
            </Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="check-types-view-label" columns={4}>Дата создания</Col>
            <Col className="check-types-view-value" columns={8}>{dateFormatter(current.created_at)}</Col>
          </Row>
        </div>
      </DialogContent>
    </Dialog>
  );
}
